import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokensays: "",
    adminsays: []
  },
  mutations: {
    login(state, data) {
      state.adminsays = data.user;
      state.tokensays = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminsays = [];
      state.tokensays = "";
    },
    adminsays(state, data) {
      state.adminsays = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminsays", data);
    }
  }
});
